module.exports = __webpack_public_path__ + "static/media/favicon.c8ce1ff3.png";